import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import moment from "moment";
import DurationHelper from './DurationHelper';


class Duration extends Component {

    render() {

        const duration = DurationHelper.calculateDuration(this.props.intl, this.props.duration, this.props.durationInSeconds)

        return (
            <div>
                {duration}
            </ div >
        )
    }

}

export default injectIntl(Duration)


// WEBPACK FOOTER //
// ./src/common/date/duration.component.jsx